import {
  getAffiliateTraits,
  postAffiliateTrait, putAffiliateTrait,
  exportAffiliateTraits, exportAffiliateTraitsHistory, importAffiliateTraits,
} from '../../../Api/services/backoffice';

import status from '../../../Utils/Select/optionsLists/status';

export const key = 'affiliateTrait';

const entityName = {
  singular: 'Traço da Filial',
  plural: 'Traços das Filiais',
};

const queries = {
  list: { key, fn: getAffiliateTraits },
  detail: { key },
};

const mutations = {
  create: postAffiliateTrait,
  update: putAffiliateTrait,
};

const fields = {
  table: [
    { key: 'trait.name', label: 'Traço' },
    { key: 'trait.traitFamily.name', label: 'Família' },
    { key: 'affiliate.name', label: 'Filial' },
    { key: 'mccOthersCVDiesel', label: 'MCC' },
    { key: 'status', label: 'Status', mustRender: { componentType: 'status' } },
  ],
  search: [
    {
      param: 'traitId',
      label: 'Traço',
      type: 'select',
      optionType: 'allTraits',
    },
    {
      param: 'familyId',
      label: 'Família',
      type: 'select',
      optionType: 'traitFamilies',
    },
    {
      param: 'affiliateId',
      label: 'Filial',
      type: 'select',
      optionType: 'affiliates',
    },
    {
      param: 'status',
      label: 'Status',
      type: 'select',
      options: status,
    },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
  exportLabel: 'Exportar Histórico',
  exportFn: exportAffiliateTraitsHistory,
  showBatchButton: true,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};

export const batchConfig = {
  entityName: entityName.plural,
  exportFn: exportAffiliateTraits,
  importFn: importAffiliateTraits,
};
